module.exports = __webpack_public_path__ + "static/media/39.d645a967.png";